module.exports = __webpack_public_path__ + "media/images/font/Gustavo-LightItalic-9a58a11ffd22861c958594769555e79d.svg";